import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Player } from '../../models/player.model';
import { AllScores } from '../../models/score.model';
import { UserService } from '../../services/user.service';
import { ScoreService } from '../scores/scores.service';




@Component({
  selector: 'superallscores',
  templateUrl: './superallscores.component.html',
  styleUrls: ['./superallscores.component.scss']
})
export class SuperAllScoresComponent implements AfterViewInit {
  public busy: boolean = true;
  public allScores: AllScores[] = [];
  public player: Player = new Player();
  public debug: boolean = false;

  constructor(private aRoute: ActivatedRoute,
    private userSvc: UserService, private scoreSvc: ScoreService) {
  }

  ngAfterViewInit(): void {
    this.aRoute.queryParams.subscribe(params => this.debug = !!params.debug);

    const p1 = this.userSvc.getUser();
    const p2 = this.scoreSvc.superallScores();
    forkJoin([p1, p2]).subscribe(
      (resp) => {
        this.player = new Player(resp[0]);
        this.allScores.length = 0;
        // resp[1].forEach(p => {
        //   const as = new AllScores(p);
        //   this.allScores.push(as);
        // });
        this.busy = false;
      },
      (err) => this.busy = false
    )
  }

}
